/** Shared select styling for location fields on light dashboard forms. */
export const locationSelectSx = {
  "& .MuiSelect-select": {
    color: "#000",
  },
  "& .MuiInputLabel-root": {
    color: "#6a31dc",
  },
};

export const locationSelectMenuProps = {
  PaperProps: {
    sx: {
      "& .MuiMenuItem-root": {
        color: "#000",
      },
    },
  },
};

export const locationSelectSlotProps = {
  select: {
    MenuProps: locationSelectMenuProps,
  },
};
